<template>
    <div class="loader" :style="{height: loaderHeight + 'px'}" :class="{'is-active': isActive, 'is-grey': grey}">
        <span class="loader__spinner"></span>
    </div>
</template>

<script>
// import EventHub from '@/utils/EventHub'
import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock'

  export default {
    name: 'AppLoader',

    props: {
        grey: {
            default: false,
            type: Boolean
        }
    },

    data() {
      return {
          loaderHeight: 0,
          isActive: false
      }
    },

    created()
    {
        // EventHub.$on('window:resize', this.onResize)
    },

    mounted()
    {
        // this.onResize({width: window.innerWidth, height: window.innerHeight})
    },

    destroyed()
    {
        clearAllBodyScrollLocks()
        // EventHub.$off('window:resize', this.onResize)
    },

    methods: {
        enable()
        {
            this.calculateHeight()
            this.isActive = true
            disableBodyScroll()
        },

        disable()
        {
            this.isActive = false
            enableBodyScroll()
        },

        calculateHeight()
        {
            this.loaderHeight = window.innerHeight - this.$el.getBoundingClientRect().top
        },
    }
  }
</script>

<style lang="stylus">

.loader
    z-index 4
    position absolute
    top 0
    left 0
    width 100%
    height 100%
    display flex
    align-items center
    justify-content center
    background $beige
    opacity 0
    visibility hidden

    &.is-grey
        background $grey

    &.is-active
        opacity 1
        visibility visible

.loader__spinner
    width 35px
    height 35px
    border 4px solid rgba(13, 13, 22, 0.2)
    border-top-color $black
    border-radius 50%
    animation rotate .7s linear infinite

@keyframes rotate {
    100% {
        transform rotate(360deg)
    }
}
</style>